// src/features/auth/signup/services/signupService.ts

import {
  AUTH_ENDPOINTS,
  STORE_ENDPOINTS,
} from '../../../../api';

import api from '../../../../api/axios';

import type {
  DuplicateCheckResponse,
  DuplicateField,
  SignupRequest,
  StoreListResponse,
} from '../types/signup.types';


/**
 * 중복 확인 필드별 Endpoint
 */
const DUPLICATE_ENDPOINTS: Record<
  DuplicateField,
  string
> = {
  userId:
    AUTH_ENDPOINTS.CHECK_ID,

  userNickname:
    AUTH_ENDPOINTS.CHECK_NICKNAME,
};


export const signupService = {

  /**
   * 회원가입용 매장 목록 조회
   */
  async getStores() {
    return api.get<StoreListResponse>(
      STORE_ENDPOINTS.LIST,
    );
  },


  /**
   * 아이디 / 닉네임 중복 확인
   */
  async checkDuplicate(
    field: DuplicateField,
    value: string,
  ) {
    return api.get<DuplicateCheckResponse>(
      DUPLICATE_ENDPOINTS[field],
      {
        params: {
          [field]: value,
        },
      },
    );
  },


  /**
   * 회원가입
   */
  async signup(
    request: SignupRequest,
  ) {
    return api.post(
      AUTH_ENDPOINTS.SIGNUP,
      request,
    );
  },

};